import {
    FETCH_PENDING_COMMISSIONS_REQUEST,
    FETCH_PENDING_COMMISSIONS_SUCCESS,
    FETCH_PENDING_COMMISSIONS_FAILURE,
} from "../actions/types";

const initialState = {
    commissions: [],
    pagination: {
        page: 1,
        size: 10,
        total: 0,
        pages: 0,
    },
    loading: false,
    error: null,
};

export default function pendingCommissionReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_PENDING_COMMISSIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PENDING_COMMISSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                commissions:
                    action.payload.items,
                pagination:
                    action.payload.pagination,
            };

        case FETCH_PENDING_COMMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}